import React from 'react'
import {
  FaCheckCircle,
  FaDollarSign,
  FaFileContract,
  FaFileSignature,
  FaTruck,
  FaClinicMedical,
} from 'react-icons/fa'

type IconComponent = React.ComponentType<{ size?: number; color?: string }>

const ORDER_COLORS = ['#4d61aa', '#FA5A84']

const EVENT_ICON_MAP: Record<string, IconComponent> = {
  reservation_confirmed: FaCheckCircle,
  sample_proof_approved: FaDollarSign,
  sample_proof_rejected: FaDollarSign,
  transport_proof_approved: FaDollarSign,
  transport_proof_rejected: FaDollarSign,
  fill_contract: FaFileContract,
  fill_tcle: FaFileContract,
  contract_signed: FaFileSignature,
  send_scheduled: FaTruck,
  sended: FaClinicMedical,
}

/**
 * Returns the react-icon component for a given notification event type.
 * Falls back to FaCheckCircle if unknown.
 */
export const getNotificationIcon = (eventType: string): IconComponent =>
  EVENT_ICON_MAP[eventType] ?? FaCheckCircle

/**
 * Returns a hex color for a notification based on the zero-indexed position
 * of its order among the patient's unique orders (cycles between ORDER_COLORS).
 */
export const getNotificationColor = (orderIndex: number): string =>
  ORDER_COLORS[orderIndex % ORDER_COLORS.length]
